// extracted by mini-css-extract-plugin
export default {"img":"landingPage_img__G8DTm"};